import { useI18next } from "gatsby-plugin-react-i18next"

import LargeStat from "components/sectionTemplates/LargeStat"
import colors from "styles/colors"
import text from "styles/text"
import useMedia from "utils/useMedia"

const stopColors = ["#05A1C9", "#3D50FC", "#3D50FC"]

export default function B2BLargeStat() {
  const kickerWidth = useMedia("830px", "50vw", "60vw", "81.333vw")
  const position = useMedia("left", "left", "left", "center")
  const { t } = useI18next()

  return (
    <LargeStat
      linesTurq
      kicker={{
        size: useMedia(text.h6, text.h6, text.h6, text.bodyR),
        width: kickerWidth,
        text: t(
          "Today, 50% of B2B payments still happen by check–which means there’s a $200 trillion opportunity for digital B2B payments over the next decade."
        ),
      }}
      stopColors={stopColors}
      wave={{
        bottomStopColors: [colors.seaFoam100],
        topStopColors: [colors.lightMode],
      }}
      tooltip={{
        text: (
          <>
            {t("As seen on")}{" "}
            <a
              href="https://www.mastercard.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Mastercard
            </a>{" "}
            &{" "}
            <a
              href="https://www.getbalance.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Getbalance
            </a>
          </>
        ),
        position,
      }}
      title={{
        text: useMedia(
          t("$200,000,000,000,000"),
          t("$200,000,000,000,000"),
          t("$200,000,000,000,000"),
          "$200 Trillion"
        ),
        size: useMedia(text.largeStat, text.largeStat, text.stat2, text.h1MobileNew),
      }}
    />
  )
}
